import { call } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { signalingContentWhiteboardUpdated } from 'features/content-whiteboard/actions';
import {
  contentBoard,
  ContentWhiteboardRemoteUpdateData,
} from 'features/content-whiteboard/utils/contentBoardStateManager';

export function* onContentWhiteboardChangedSaga(
  action: ReturnType<typeof signalingContentWhiteboardUpdated>
) {
  if (
    contentBoard.type !== 'file' ||
    contentBoard.id !== action.payload.id ||
    contentBoard.currentPage !== action.payload.page
  ) {
    return;
  }

  const data: ContentWhiteboardRemoteUpdateData = {
    changed: [],
    removed: [],
  };

  try {
    data.removed = action.payload.removed;
    data.changed = action.payload.changed.map((row: any) => JSON.parse(row.data));

    yield call(contentBoard.acceptRemoteChanges, data);
  } catch (error) {
    Sentry.captureException(error);
  }
}
